class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    this.addEventListener('mouseenter', this.open.bind(this));
    this.addEventListener('mouseleave', this.close.bind(this));
    this.addEventListener('focusin', this.open.bind(this));
    this.querySelectorAll('details details').forEach((details) => {
      details.addEventListener('mouseenter', () => this.openDetails(details));
      details.addEventListener('mouseleave', () => this.closeDetails(details));
      details.addEventListener('focusin', () => this.openDetails(details));
      details.addEventListener('focusout', () => {
        setTimeout(() => {
          if (!details.contains(document.activeElement)) this.closeDetails(details);
        });
      });
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  open() {
    this.closeSiblingMenus();
    this.openDetails(this.mainDetailsToggle);
  }

  openDetails(details) {
    details.setAttribute('open', '');
    details.querySelector('summary')?.setAttribute('aria-expanded', true);
  }

  close() {
    this.querySelectorAll('details[open]').forEach((details) => this.closeDetails(details));
  }

  closeDetails(details) {
    details.removeAttribute('open');
    details.querySelector('summary')?.setAttribute('aria-expanded', false);
  }

  closeSiblingMenus() {
    this.closest('.header__inline-menu')
      ?.querySelectorAll('header-menu')
      .forEach((menu) => {
        if (menu !== this) menu.close();
      });
  }
}

customElements.define('header-menu', HeaderMenu);
